import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import PatientNote from "components/pages/transmissions/modal/detail/notes/patient_notes/PatientNote";

import { Accordion, AccordionSummary } from "@mui/material";

import {
  ExpandMore as ExpandMoreIcon,
  PushPin as PushPinIcon,
} from "@mui/icons-material";
import {
  changeExpansion,
  loadPatientNotes,
  setCurrentPatientNote,
} from "app/store/transmission/slice/transmissionSlice";

import PatientNoteForm from "components/pages/transmissions/modal/detail/notes/patient_notes/PatientNoteForm";
import usePatientNotes from "components/pages/transmissions/modal/detail/notes/patient_notes/usePatientNotes";

const PatientNotes = ({ data }) => {
  const { theme, patientNotesExpanded, patientNoteList, dispatch, handleNote } =
    usePatientNotes(data);

  const { isArchiveReport } = useSelector((state) => state.archiveReport);
  const isConnectivityReport = data?.transmissionType === "connectivityStatus";

  useEffect(() => {
    data &&
      dispatch(
        loadPatientNotes(
          data?.patientNotes && data?.patientNotes.length > 0
            ? data?.patientNotes
            : data?.patient?.clinician_notes
        )
      );

    return () => data && dispatch(loadPatientNotes([]));
  }, [data, dispatch]);

  return (
    <Accordion
      disabled={isConnectivityReport}
      disableGutters
      className="view-pdf__panel patient_notes"
      style={{
        boxShadow: "none",
        borderColor:
          theme.palette.type === "dark"
            ? "rgba(255, 255, 255, 0.12)"
            : "#E0E0E0",
      }}
      sx={{
        "&.Mui-disabled": {
          backgroundColor: theme.palette.background.paper,
        },
      }}
      expanded={isConnectivityReport ? false : patientNotesExpanded}
      onChange={(e, expanded) => {
        if (!data?.legacy && !isArchiveReport) {
          e.preventDefault();
          dispatch(setCurrentPatientNote({}));
          dispatch(changeExpansion({ type: "patientNotes", value: expanded }));
        }
      }}
    >
      <AccordionSummary
        style={{ alignItems: "center" }}
        expandIcon={
          !data?.legacy &&
          !isArchiveReport &&
          !isConnectivityReport && (
            <ExpandMoreIcon data-action="expand-more-patient-notes-icon" />
          )
        }
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            "&:hover": !data?.legacy && {
              backgroundColor:
                theme.palette.type === "dark"
                  ? "rgba(255, 255, 255, 0.12)"
                  : "#E0E0E0",
            },
          }}
        >
          <span className="view-pdf__notes-header--icon">
            <PushPinIcon />
          </span>
          {patientNoteList?.length > 0 ? (
            <div className="view-pdf__notes-header">
              {patientNoteList?.map((note, index) => (
                <PatientNote
                  key={index}
                  note={note}
                  index={index}
                  rowData={data}
                  onDelete={handleNote}
                />
              ))}
            </div>
          ) : (
            <div className="view-pdf__notes-header--title">Patient Notes</div>
          )}
        </div>
      </AccordionSummary>
      <PatientNoteForm data={data} />
    </Accordion>
  );
};

export default PatientNotes;
